module.exports = __webpack_public_path__ + "static/media/genblock.37980642.svg";